import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const OnboardingSignUp: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [businessName, setBusinessName] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Sign up logic with Supabase
    navigate('/onboarding/plan');
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-md bg-white rounded-lg shadow p-8 mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center">Sign Up</h2>
      <div className="mb-4">
        <label className="block mb-1 font-medium">Email</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="w-full border rounded px-3 py-2" />
      </div>
      <div className="mb-4">
        <label className="block mb-1 font-medium">Password</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="w-full border rounded px-3 py-2" />
      </div>
      <div className="mb-6">
        <label className="block mb-1 font-medium">Business Name</label>
        <input type="text" value={businessName} onChange={e => setBusinessName(e.target.value)} required className="w-full border rounded px-3 py-2" />
      </div>
      
      <div className="mb-6">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="terms"
              name="terms"
              type="checkbox"
              required
              className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
            />
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="terms" className="text-gray-700">
              I agree to the{' '}
              <a 
                href="/terms-and-conditions" 
                target="_blank"
                className="text-primary hover:text-primary/90 underline"
              >
                Terms and Conditions
              </a>
              {' '}and{' '}
              <a 
                href="/privacy-policy" 
                target="_blank"
                className="text-primary hover:text-primary/90 underline"
              >
                Privacy Policy
              </a>
            </label>
          </div>
        </div>
      </div>
      
      <button type="submit" className="w-full bg-primary text-white py-2 rounded font-semibold">Continue</button>
    </form>
  );
};

export default OnboardingSignUp; 